import { IoSearchSharp } from "react-icons/io5"
import { usePairSelect } from "./core"
import { Text, useMainContext, useWindowSize } from "../../../../modules/Dashboard"
import PairImg from "../../components/PairImg"
import { ReactComponent as PairVector } from '../../assets/icons/choose-pair-vector.svg';
import { ScaleLoader } from "react-spinners";
import MenuCandyIcon from "../../../../components/icons/MenuCandyIcon";
import { MOBILE_SIZE } from "../../../../core/constants/common";
import ModalLayout from "../../../../components/layouts/ModalLayout";
import MobileModal from "../../../../components/layouts/MobileModal";

const PairSelect = ({ className = "" }) => {
    const {
        ticker,
        search,
        setSearch,
        tickers,
        isFetching,
        isError,
        refetch,
        handleSelect,
        open,
        setOpen
    } = usePairSelect()
    const { width } = useWindowSize()
    const { main: { lang } } = useMainContext()

    const renderTickersCard = (sCount = 0) => {
        return (
            <>
                {tickers?.slice(0, sCount || (tickers.length))?.map(item => (
                    <button
                        key={item.ticker}
                        onClick={() => handleSelect(item.ticker)}
                        className={`
                            flex items-center gap-2 p-3 md:p-5 rounded-xl border dark:border-[#AD46FF4D] transition 
                            ${item.ticker === ticker ? "bg-gradient-to-bl from-[#9810FA4D] to-[#FF69004D] shadow-lg shadow-[#AD46FF33] " : "dark:bg-secondaryBgDark"}
                        `}
                    >
                        <PairImg ticker={item.ticker} size={width <= MOBILE_SIZE ? 16 : 20} />
                        <span className="font-medium text-sm md:text-base text-white">{item.ticker}</span>
                    </button>
                ))}
            </>
        )
    }

    return (
        <>
            <div className='flex items-center gap-2'>
                <PairVector width={40} height={40} />
                <Text tid="choose-pair" className='text-xl' />
            </div>
            <div className={`flex flex-col gap-4 w-full ${className} `}>

                {/* === Search Input === */}
                <div className="relative">
                    <IoSearchSharp
                        size={23}
                        className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
                    />
                    <input
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        placeholder={lang === "fa" ? "جستجوی ارز..." : "Search pairs (e.g., BTC, BTC/USDT)..."}
                        className="w-full bg-gray-100 dark:bg-secondaryBgDark h-[48px] px-11 py-1 rounded-xl outline-none border border-[#364153] placeholder:text-[#6A7282] text-sm"
                    />
                </div>

                {/* === Loading === */}
                {isFetching && (
                    <div className="flex justify-center items-center mt-6">
                        <ScaleLoader color='#9F64DF' />
                    </div>
                )}

                {/* === Error === */}
                {isError && (
                    <div className="flex flex-col items-center gap-2 py-6">
                        <Text tid="error" />
                        <button
                            onClick={refetch}
                            className="px-4 py-1 bg-red-500 text-white rounded-md"
                        >
                            {lang === "fa" ? "تلاش مجدد" : "Retry"}
                        </button>
                    </div>
                )}

                {/* === No Results === */}
                {!isFetching && !isError && tickers?.length === 0 && (
                    <div className="text-center py-6 text-sm opacity-60">
                        {lang === "fa" ? "موردی یافت نشد" : "No results found"}
                    </div>
                )}

                {/* === Cards Grid === */}
                {
                    (tickers.length > 0) &&
                    <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3">
                        {renderTickersCard(7)}
                        {/* VIEW MORE BUTTON */}
                        {
                            !search &&
                            <button
                                onClick={() => setOpen(true)}
                                className={`
                            flex items-center justify-center gap-2 p-3 md:p-5 rounded-xl bg-gradient-to-r from-[#FC6432] to-[#B025C1]  transition `}
                            >
                                <MenuCandyIcon size={18} color="#ffffff" />
                                <Text tid={'view-all'} className="font-medium " />
                            </button>
                        }
                    </div>
                }

            </div>

            {(tickers.length > 0) &&
                <>
                    {width >= MOBILE_SIZE ?
                        <ModalLayout open={open} onClose={() => { setOpen(false) }} width={"700px"} title={"choose-pair"}>
                            <div className="grid grid-cols-3 gap-3 max-h-[300px] overflow-auto px-6">
                                {renderTickersCard()}
                            </div>
                        </ModalLayout>
                        :
                        <MobileModal isOpen={open} onClose={() => { setOpen(false) }} title={"choose-pair"}>
                            <div className="grid grid-cols-2  gap-3 max-h-[300px] overflow-auto px-6">
                                {renderTickersCard()}
                            </div>
                        </MobileModal>}
                </>
            }

        </>
    )
}

export default PairSelect
